export enum DmsOpCode {
  NEWLY_ADDED_PHOTO = 'N',
  SUBMITTED_AND_PENDING_PHOTO = 'P'
}
